module.exports = __webpack_public_path__ + "img/image1.b8e66e83.jpg";